var Positioning = /* @__PURE__ */ ((Positioning2) => {
  Positioning2["absolute"] = "absolute";
  Positioning2["fixed"] = "fixed";
  Positioning2["relative"] = "relative";
  Positioning2["static"] = "static";
  Positioning2["sticky"] = "sticky";
  Positioning2["inherit"] = "inherit";
  Positioning2["initial"] = "initial";
  Positioning2["revert"] = "revert";
  Positioning2["revertLayer"] = "revert-layer";
  Positioning2["unset"] = "unset";
  return Positioning2;
})(Positioning || {});
export {
  Positioning
};
//# sourceMappingURL=positioning.es.js.map
